import { render, staticRenderFns } from "./EventCreateTickets.vue?vue&type=template&id=6bfab114&"
import script from "./EventCreateTickets.vue?vue&type=script&lang=js&"
export * from "./EventCreateTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfab114')) {
      api.createRecord('6bfab114', component.options)
    } else {
      api.reload('6bfab114', component.options)
    }
    module.hot.accept("./EventCreateTickets.vue?vue&type=template&id=6bfab114&", function () {
      api.rerender('6bfab114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateTickets.vue"
export default component.exports